import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "./header/header";
import "./doyenaccesSuccess.css";

const DoyenaccessCancel = () => {
  const navigate = useNavigate();

  return (
    <div>
      <Header />

      <div style={{ width: "100%", overflowX: "hidden", overflowY: "hidden" }}>
        <div className="text-center successdoyenaccess">
          <div className="row">
            <div className="col-md-4"></div>
            <div className="col-md-4">
              <div
                style={{
                  backgroundColor: "#f5f8f8",
                  borderRadius: "10px",
                  paddingTop: "25px",
                  paddingBottom: "55px",
                }}
              >
                <img
                  src="../../images/Cancelimg.png"
                  alt="cancelimg"
                  style={{ paddingBottom: "30px" }}
                />
                <h2>Transaction Cancelled</h2>
                <button
                  className="btn btn-danger"
                  onClick={() => {
                    navigate("/doyenaccess");
                  }}
                >
                  Back to DoyenAccess
                </button>
              </div>
            </div>
            <div className="col-md-4"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoyenaccessCancel;
